/**
 * Normalizes the selected solution's display name into the value shown in the
 * "Edit Solution Name" input on the Versions page.
 *
 * The input value MUST derive only from the currently selected solution — this
 * helper is intentionally stateless so a previously edited/viewed solution's
 * name can never leak into another solution's input (PSTUDIO-2754).
 */
export const getEditableSolutionName = (displayName?: string | null): string =>
  displayName ?? '';
